import { useTranslation } from "react-i18next";

export default function FinalCTASection() {
  const { t } = useTranslation();

  const scrollToRegister = () => {
    const element = document.getElementById("register");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-r from-teal-600 to-teal-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-8 leading-tight">
          {t("final_title")}
        </h2>
        <button
          onClick={scrollToRegister}
          className="bg-white text-teal-700 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          {t("final_cta")}
        </button>
      </div>
    </section>
  );
}
